import EventEmitter from 'eventemitter3';

import { registerEmitter, unregisterEmitter } from '@/shared/utils/hmr-manager';

export class TypedEmitter<T extends Record<string, unknown>> extends EventEmitter<T> {
  constructor() {
    super();
    // Register with centralized HMR manager for unified cleanup
    try {
      registerEmitter(this as unknown as EventEmitter<any>);
    } catch (e) {
      // ignore registration failures
    }
  }

  // Ensure emitters created in modules are cleaned up by .dispose or by HMR manager

  override on<K extends keyof T>(event: K, listener: (arg: T[K]) => void): this {
    return super.on(
      event as EventEmitter.EventNames<T>,
      listener as EventEmitter.EventListener<T, EventEmitter.EventNames<T>>
    );
  }

  override emit<K extends keyof T>(event: K, ...args: T[K][]): boolean {
    return super.emit(
      event as EventEmitter.EventNames<T>,
      ...(args as EventEmitter.EventArgs<T, EventEmitter.EventNames<T>>)
    );
  }

  // Allow explicit disposal when an emitter is no longer needed
  dispose() {
    try {
      this.removeAllListeners();
    } finally {
      try {
        unregisterEmitter(this as unknown as EventEmitter<any>);
      } catch (e) {
        // ignore
      }
    }
  }
}
